<template>
  <section style="">
    <div id="mundo">
      <img src="~@/assets/bola_mundo.png" alt="">
    </div>
    <div class="columns is-centered">
      <div class="column is-5-desktop is-8-tablet is-12-mobile content" style="z-index: 1;">
        <div class="container section">
          <b class="title is-5 is-pink">
            {{ $t('Estado de su solicitud') }}
          </b>
          <br>
          <b>{{$t('P1ST1')}}</b>
          <br>
          <b>{{$t('P1ST2')}}</b>
          <br>
          <b>{{$t('P1ST3')}}</b>
          <hr>
          <b-loading
            :is-full-page="true"
            :active.sync="isLoading"
            :can-cancel="false"
          ></b-loading>
          <options-viewer :optionsObject="neofintechData.phase1" />
        </div>
      </div>
    </div>
    
  </section>
</template>

<script>
import Fetcher from '@/mixins/fetcher.js'
import { mapGetters, mapActions } from 'vuex'
import EnumeratesFormater from '@/mixins/enumeratesFormater.js'
import OptionsViewer from '@/components/on-board/OptionsViewer.vue'

export default {
  props: ['id'],
  mixins: [EnumeratesFormater, Fetcher],
  components: { OptionsViewer },
  data() {
    return {
      isLoading: false,
      requestData: {
        phase1: null
      }
    }
  },
  mounted() {
    this.loadRequestData()
  },
  computed: {
    ...mapGetters('onBoard', ['neofintechData'])
  },
  beforeRouteLeave(routeTo, routeFrom, next) {
    this.$store.commit('onBoard/SET_NEOFINTECH_PHASE_1_RESET')
    next()
  },
  methods: {
    ...mapActions('onBoard', ['getOnboardRequestDetails']),
    loadRequestData: function() {
      let self = this
      self.request(() =>
      self.getOnboardRequestDetails(self.id)
        .then(function(response) {
          self.$store.commit(
            'onBoard/SET_NEOFINTECH_PHASE_1',
            response.data.phase1
          )
        }))
    },
    goToPhase2: function() {
      let self = this
      self.$router.push({
        name: 'onBoard.neofintech.phase2.1'
      })
    }
  }
}
</script>

<style>
#mundo {
  position: fixed;
  top: 60;
  right: -100px;
  width: 60vh;
  z-index: 0;
}
</style>
